import { NotificationType } from './notification-type';

export class NotificationMessage {
  message: string;
  type: NotificationType;

  constructor(
    message: string,
    type: NotificationType,
  ) {
    this.message = message;
    this.type = type;
  }
}
